import React, {useState, useEffect} from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import 'bootstrap/dist/css/bootstrap.min.css';

import appSettings from "../../appSettings.json";
import './NewTicket.css';
import RichTextEdit from '../RichTextEdit/RichTextEdit';
import AttachTicket from '../AttachTicket/AttachTicket';
import useFetch from '../../shared/hooks/useFetch.js';
import isFilled from '../../shared/utilities/isFilled';

const validate = (values) => {
    const errors = {}

    if(!values.asunto){ errors.asunto = 'Campo requerido' }

    return errors
}

const NewTicket = (props) => {
    // props y inicializacion
    const { user, usersSAT, close, renderView, setRenderView, installations, dataTicketsAux} = props
    const [texto, setTexto] = useState('');
    const [flagTextoRes, setFlagTextoRes] = useState(0) // flag auxiliar para controlar la sincronización

    // Parte adjuntos
    const [adjuntoRes, setAdjuntoRes] = useState([]) // archivos subidos al sw pero no linkeado con el ticket
    const [flagAdjuntoRes, setFlagAdjuntoRes] = useState(0) // flag auxiliar para controlar la sincronización

    // URLs
    const newTicket = `${appSettings.BASE_URL.default}/ticket/upsert`;
    const getTypes = `${appSettings.BASE_URL.default}/ticket/get-types`;
    const getUsers = `${appSettings.BASE_URL.default}/ticket/get-users?role=*`;

    // LLamada API metodo getTypes
    const[dataTypes, setDataTypes] = useState("");
    const[messageTypes, setMessageTypes] = useState("");
    const[successTypes, setSuccessTypes] = useState(false);

    const {serviceResponse: serviceResponseTypes, error: errorTypes, loading: loadingTypes} = useFetch(getTypes, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token}, 'GET')

    useEffect(() => {
        if(!loadingTypes){
            setDataTypes(serviceResponseTypes.data)
            setMessageTypes(serviceResponseTypes.message)
            setSuccessTypes(serviceResponseTypes.success)
        }
    }, [loadingTypes, serviceResponseTypes, errorTypes])

    // LLamada API metodo getUsers
    const[dataUsers, setDataUsers] = useState("");
    const[messageUsers, setMessageUsers] = useState("");
    const[successUsers, setSuccessUsers] = useState(false);

    const {serviceResponse: serviceResponseUsers, error: errorUsers, loading: loadingUsers} = useFetch(getUsers, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token}, 'GET')

    useEffect(() => {
        if(!loadingUsers){
            setDataUsers(serviceResponseUsers.data)
            setMessageUsers(serviceResponseUsers.message)
            setSuccessUsers(serviceResponseUsers.success)
        }
    }, [loadingUsers, serviceResponseUsers, errorUsers])

    // LLamada API metodo new Ticket
    const[dataNew, setDataNew] = useState("");
    const[messageNew, setMessageNew] = useState("");
    const[successNew, setSuccessNew] = useState(false);

    const[body, setBody] = useState();
    const {serviceResponse: serviceResponseNew, error: errorNew, loading: loadingNew} = useFetch(newTicket, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token}, 'POST', body)

    useEffect(() => {
        if(!loadingNew){
            setDataNew(serviceResponseNew.data)
            setMessageNew(serviceResponseNew.message)
            setSuccessNew(serviceResponseNew.success)

            setRenderView(!renderView)
            close()
        }
    }, [loadingNew, serviceResponseNew, errorNew])

    // Manejador de submit formik
    const [endValues, setEndValues] = useState()
    const handleSubmit = async () => {
        flagAdjuntoRes === 0 && setFlagAdjuntoRes(1); // si el flag es 0 actualizo a 1 para indicar que empieza. Hata que no llega a 2 no ha acabado el proceso.

        if ((flagTextoRes === 0 || flagTextoRes === 2) && flagAdjuntoRes === 2 && isFilled(endValues))
        {    
            setBody(JSON.stringify({
                "Ticket":
                {
                    "UsuarioId": endValues.usuario,
                    "TipoId": endValues.tipo,
                    "Urgencia": endValues.urgencia,
                    "Asunto": endValues.asunto,
                    "Mensaje": [
                        {
                            "contenido": texto,
                            "usuarioId": endValues.usuario,
                        }
                    ],
                    ...(isFilled(adjuntoRes) && {
                        "Adjunto": adjuntoRes.map((adjunto) => (
                            {
                                "nombreId": adjunto.nombreId,
                                "nombre": adjunto.nombre,
                                "size": adjunto.size,
                                "usuarioId": endValues.usuario
                            }
                        ))
                    }),
                    "Responsable": endValues.responsable,
                    "Notificar": endValues.notificar
                }
            }))

            setFlagAdjuntoRes(0);
            setFlagTextoRes(0);
        }
    };

    useEffect(() => {
        if((flagAdjuntoRes === 1 || flagAdjuntoRes === 2)) { handleSubmit() }
    }, [flagAdjuntoRes, flagTextoRes, endValues]);

    return(
        <div className='container-fluid'>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successTypes && !loadingTypes} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al obtener los tipos. Mensaje API: " + messageTypes}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successUsers && !loadingUsers} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al obtener los tipos. Mensaje API: " + messageUsers}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successNew && !loadingNew && isFilled(messageNew)} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al crear el ticket. Mensaje API: " + messageNew}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={successNew && !loadingNew} onClose={() => {setSuccessNew(false)}}>
                <Alert severity="success" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Nuevo ticket creado"}
                </Alert>
            </Snackbar>
            <Formik
                initialValues={{ instalacion: user.instalacion, usuario: user.idLogin, tipo: 2, urgencia: 0, asunto: '', responsable: "", notificar: true}}
                enableReinitialize = {true}
                validate = {validate}
                onSubmit={(values) => {
                    setEndValues(values)
                    handleSubmit() // Llamada a handleSubmit
                }}
            >
                {({ isSubmitting, values, setFieldValue}) => (
                    <Form>
                        <div className='row' style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <div className='col-4 d-inline-flex flex-row'>
                                <h5 style={{fontWeight: "500", marginTop: "10px"}}>Nuevo Ticket</h5>
                            </div>
                            <div className='col d-inline-flex flex-row-reverse'>
                                <button type = "button" className = 'btn' onClick={() => close()}>Cancelar</button>
                                <button type = "submit" disabled={isSubmitting} className = 'btn btn-outline-success'>Crear Ticket</button>
                            </div>
                        </div>
                        <hr />
                        <div className='row'>
                            <div className='col' style={{fontSize: "13px"}}>
                                <span style={{fontWeight: "450"}}>{`${user.installationId} - ${user.installation}. `}</span>
                                <span style={{fontWeight: "650"}}>{`${user.name}`}</span>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-5">
                                <div className='row rowForm' style={{display: user.role == 7 ? '' : 'none'}}>
                                    <div className='col-2 col-form-label d-inline-flex flex-row-reverse'>
                                        <label htmlFor="instalacion">Instalación:</label>
                                    </div>
                                    <div className='col'>
                                        <Field id="instalacion" name="instalacion" className="form-select" as="select"
                                        onChange={(event) => {
                                            const newInstallation = event.target.value;
                                            setFieldValue("instalacion", newInstallation);

                                            if (isFilled(dataTicketsAux)) {
                                            const nextTicketsForUsers =
                                                newInstallation !== "*"
                                                ? dataTicketsAux.filter(
                                                    ticketResponse =>
                                                        ticketResponse.instalacionUsuario === newInstallation
                                                    )
                                                : dataTicketsAux;

                                            const nextUsers = [
                                                ...new Map(
                                                nextTicketsForUsers.map(ticketResponse => [
                                                    ticketResponse.nombreUsuario,
                                                    ticketResponse.nombreUsuario
                                                ])
                                                ).values()
                                            ];

                                            if (
                                                values &&
                                                values.usuario &&
                                                values.usuario !== "*" &&
                                                !nextUsers.includes(values.usuario)
                                            ) {
                                                setFieldValue("usuario", "*");
                                            }
                                            }
                                        }}
                                        >
                                        <option value="*">*</option>
                                        {installations.map((installation, i) => (
                                            <option key={i} value={installation}>
                                            {installation}
                                            </option>
                                        ))}
                                        </Field>
                                    </div>
                                    </div>
                                <div className='row rowForm' style={{display: user.role == 7 ? '' : 'none'}}>
                                    <div className='col-2 col-form-label d-inline-flex flex-row-reverse'>
                                        <label htmlFor="usuario">Creador:</label>
                                    </div>
                                    <div className='col'>
                                        {isFilled(dataUsers)
                                            ?
                                            <Field id="usuario" name="usuario" className="form-select" as="select">
                                                <option value="*">*</option>

                                                {dataUsers
                                                .filter(userData =>
                                                    !values.instalacion || values.instalacion === "*"
                                                    ? true
                                                    : userData.instalacion === values.instalacion.substring(0, userData.instalacion.length)
                                                )
                                                .map((userData) => (
                                                    <option
                                                    key={userData.usuarioId}
                                                    value={userData.usuarioId}
                                                    >
                                                    {`${userData.nombre}`}
                                                    </option>
                                                ))
                                                }
                                            </Field>
                                            :
                                            <></>
                                        }
                                    </div>
                                </div>
                                <div className='row rowForm'>
                                    <div className='col-2 col-form-label d-inline-flex flex-row-reverse'>
                                        <label htmlFor="tipo">Tipo:</label>
                                    </div>
                                    <div className='col'>
                                        {isFilled(dataTypes) 
                                        ?
                                            <Field id = "tipo" name="tipo" className="form-select" as="select">
                                                {dataTypes.map((type, i) => (
                                                    <option key={type.tipoId} value={type.tipoId}>{type.nombre}</option>
                                                ))}
                                            </Field>
                                        :
                                            <></>
                                        }
                                    </div>
                                </div>
                                <div className='row rowForm' style={{display: user.role == 7 ? '' : 'none'}}>
                                    <div className='col-2 col-form-label d-inline-flex flex-row-reverse'>
                                        <label htmlFor="urgencia">Urgencia:</label>
                                    </div>
                                    <div className='col'>
                                        <Field id="urgencia" name="urgencia" className="form-select" as="select">
                                            <option value="0">No Urgente</option>
                                            <option value="1">Urgente</option>
                                        </Field>
                                    </div>
                                </div>
                                <div className='row rowForm' style={{display: user.role == 7 ? '' : 'none'}}>
                                    <div className='col-2 col-form-label d-inline-flex flex-row-reverse'>
                                        <label htmlFor="responsable">Responsable:</label>
                                    </div>
                                    <div className='col'>
                                        {isFilled(usersSAT) 
                                        ?
                                            <Field id="responsable" name="responsable" className="form-select" as="select">
                                                {usersSAT.map((responsable, i) => (
                                                    <option key={responsable.usuarioId} value={responsable.usuarioId}>{responsable.nombre}</option>
                                                ))}
                                            </Field>
                                        :
                                            <></>
                                        }
                                    </div>
                                </div>
                                <div className='row rowForm'>
                                    <div className='col-2 d-inline-flex flex-row-reverse'>
                                        Adjuntos:
                                    </div>
                                    <div className='col'>
                                        <AttachTicket user={user} adjuntoRes={adjuntoRes} setAdjuntoRes={setAdjuntoRes} flagAdjuntoRes={flagAdjuntoRes} setFlagAdjuntoRes={setFlagAdjuntoRes}/>
                                    </div>
                                </div>
                                <div className='row rowForm'>
                                    <div className='col-2 d-inline-flex flex-row-reverse'>
                                        <label htmlFor="notificar">Notificar:</label>
                                    </div>
                                    <div className='col'>
                                        <Field id="notificar" name="notificar" className="form-check-input" type="checkbox"></Field>
                                        <label className="form-check-label" htmlFor="notificar">&nbsp;Selecciona si se notificará via email los cambios de estado </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-7">
                                <div className='row rowForm'>
                                    <div className='col-2 col-form-label d-inline-flex flex-row-reverse'>
                                        <label htmlFor="asunto">Asunto:</label>
                                    </div>
                                    <div className='col'>
                                        <Field id="asunto" name="asunto" className="form-control" type="text"/>
                                    </div>
                                </div>
                                <ErrorMessage name="asunto">{msg => <div className='row'><div className='col-2'></div><div className='col-3' style={{color:'red'}}>{msg}</div></div>}</ErrorMessage>
                                <div className='row rowForm'>
                                    <div className='col-2 d-inline-flex flex-row-reverse'>
                                        Mensaje:
                                    </div>
                                    <div className='col richTextEditNT'>
                                        <RichTextEdit contenido={texto} setContenido={setTexto} setFlagTextoRes={setFlagTextoRes}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default NewTicket;